var path = '/components/components/contact-preview/customs/pref_email.tpl.html';
var html = "<span ng-if=\"vm.contact.preferred_email\">{{vm.contact.preferred_email}}<br/></strong>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/contact-preview/customs/pref_email.tpl.html
// module id = 1968
// module chunks = 1